"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class StringTemplate {
  static escapeRegExp(string) {
    //From https://stackoverflow.com/a/6969486
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  static replace(template, stringsValues) {
    return Object.keys(stringsValues).reduce((carry, sKey) => carry.replace(new RegExp(StringTemplate.escapeRegExp(sKey), 'g'), stringsValues[sKey]), template);
  }

  static startsWith(text, preffix) {
    return text.indexOf(preffix, 0) === 0;
  }

  static endsWith(text, suffix) {
    return text.indexOf(suffix, text.length - suffix.length) !== -1;
  }

}

exports.default = StringTemplate;